import { render, staticRenderFns } from "./HiCSVLoader.vue?vue&type=template&id=21c571a5&scoped=true&"
import script from "./HiCSVLoader.vue?vue&type=script&lang=js&"
export * from "./HiCSVLoader.vue?vue&type=script&lang=js&"
import style0 from "./HiCSVLoader.vue?vue&type=style&index=0&id=21c571a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c571a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VIcon,VSelect,VSimpleTable,VTextField})
